// extracted by mini-css-extract-plugin
export default {"item":"ReviewContentItem_item__No+Rx","tag":"ReviewContentItem_tag__GHIc8","value":"ReviewContentItem_value__Kl1HB","flexStart":"ReviewContentItem_flexStart__HK+Y2"};